// extracted by mini-css-extract-plugin
export default {"container":"Oe_ly5"};